// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.defined.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.defined.js
// module chunks = 0